/* eslint-disable */

// InvoiceForm
import { Grid, Paper, TextField, Typography, Box, Autocomplete, FormLabel, FormControl, Button, MenuItem, Menu, Fade, CircularProgress, InputAdornment, IconButton, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Close';

import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import Key from '../../../clientVariables.json';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 2,
};


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(itemid, itemName, itemDescription, uom, quantity, price) {
  return { itemid, itemName, itemDescription, uom, quantity, price };
}

const paymentTermsList = ['DOR'];
const initialState = {
  id: '', // invoice Number
  customerDetails: '',
  description: '',
  startDate: null,
  endDate: null,
  duration: '',
  period: '',
  subTotal: 0,
  tax: 0,
  grandTotal: 0,
  status: 'Entered',
  priceList: '',
  totalDiscount: 0,
  
  companyName: '',
  address1: '',
  address2: '',
  state: '',
  city: '',
  zipcode: '',
  invoiceTotal: 0,
  discount: '',
  // tax: '',
  // grandTotal: '',
  dueDate: moment(),
  invoiceDate: moment(),
  dueOnReciept: '',
};


export default function InvoiceForm({isOpenInvoiceForm, customerDetails}) {
  const styles = useResponsiveStyles();
  const currentUser = useSelector((state) => state.UserReducer.user);
  const [open, setOpen] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [rows, setRows] = useState();



  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if(isOpenInvoiceForm.isOpen){
      handleOpen();
      console.log('invoice row data', isOpenInvoiceForm);
      console.log("customer details", customerDetails);
      if(customerDetails?.state){
        getCities(customerDetails?.state);
       }
      const fetch = async () => {
        const rowData =await isOpenInvoiceForm.rowData.map((item) => createData(item.id, item.name, item.description, item.uom, item.quantity, item.price));
      setRows(rowData);
      
      const statePrev =await stateList.filter((data) => data.id == customerDetails?.state)[0];
      const cityPrev =await cityList.filter((data) => data.id == customerDetails?.city)[0];
      console.log("state city", statePrev, cityPrev);
      setFormData((prev) => ({
        ...prev,
        id:generateInvoiceId(),
        invoiceTotal: isOpenInvoiceForm.summaryData.subTotal,
        totalDiscount: isOpenInvoiceForm.summaryData.totalDiscount,
        grandTotal: isOpenInvoiceForm.summaryData.grandTotal,
        address1: customerDetails?.address1,
        address2: customerDetails?.address2,
        companyName: customerDetails?.company_name,
        state: statePrev,
        city: cityPrev,
      }));
      }
      fetch();
    }
  }, [isOpenInvoiceForm]);



  
  const handleChange = (feild, value) => {
    console.log(formData);
    setFormData((prev) => ({
      ...prev,
      [feild]: value,
    }));

  };

  const handleSubmit = async() => {
    try {
      const response =await axios.post(`${Key.domain}/payment/invoice`, {
        number: formData.id,
        admin_id: currentUser?.id,
        company_id: customerDetails?.companyid,
        customer_id: customerDetails?.id,
        contract_number: isOpenInvoiceForm?.summaryData?.id,
        invoice_date: moment(formData.invoiceDate).format('YYYY-MM-DD HH:mm:ss'),
        sub_total: formData.invoiceTotal.toString(),
        discount: formData.totalDiscount.toString(),
        tax: formData.tax.toString(),
        total: formData.grandTotal.toString(),
        payment_terms: "DOR",
        due_date: moment(formData.dueDate).format('YYYY-MM-DD HH:mm:ss'),
        address1: formData.address1,
        address2: formData.address2,
        trail_days: isOpenInvoiceForm.summaryData.trailDays,

      });
      console.log("invoice response", response);
    } catch (error) {
      console.error(error);
    }
  }

  const generateInvoiceId = () => {
    // const paddedUserId = customerDetails ? customerDetails?.id.toString().padStart(6, '0') : '0';
    const newContractId = `IN${currentUser?.id}${moment().format("YYYYMMDDhhmmss")}`;
    // console.log('moment().format("YYYYMMDDHHMM")', moment().format("YYYYMMDDhhmmss"));
    return newContractId;
  };

  const getStates = () => {
    fetch(`${Key.domain}/common/get_states_by_countryid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        country_id: 233,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setStateList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const getCities = (id) => {
    fetch(`${Key.domain}/common/get_cities_by_stateid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        state_id: id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setCityList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const getZipCodes = (id) => {
    fetch(`${Key.domain_jnp}/commonAPIs/get_zipcodes_By_cityId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        city_id: id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setZipcodes(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const textStyles = {
    fontSize: styles.fontSize12,
    fontWeight: 600,
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
           
             <Grid container spacing={0} sx={{
  maxHeight: '86%',
  overflow: 'scroll'
             }}>
              <Grid item xs={8}>
              <Grid
          container
          spacing={1}
          sx={{
            '.css-r0m7rw-MuiInputBase-root-MuiOutlinedInput-root': {
              height: '34.5px',
            },
            '& .MuiInputBase-input': {
              fontSize: '12px',
            },
            p: '10px'
          }}
        >
          <Grid item xs={12} sx={{ alignItems: 'center' }}>
            <Grid item container spacing={0} xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={2}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Number
                  </Typography>
                </Box>
              </Grid>
              <Grid xs={10}>
                <TextField
                  fullWidth
                  placeholder="Number"
                  size="small"
                  value={formData.id}
                  onChange={(e) => handleChange('id', e.target.value)}
                  // error={Boolean(formErrors.itemDescription)}
                  // helperText={formErrors.itemDescription}
                  id="id"
                  autoComplete="off"
                />
              </Grid>
              {/* <Box sx={{display: 'flex', gap:'5px', alignItems: 'center'}}>
                    
                   
                    </Box> */}
            </Grid>
          </Grid>
          
          <Grid item xs={12} sx={{ alignItems: 'center' }}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={2}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Company
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth disabled
                  placeholder="Company Name"
                  size="small"
                  value={formData.companyName}
                  onChange={(e) => handleChange('companyName', e.target.value)}
                  // error={Boolean(formErrors.companyName)}
                  // helperText={formErrors.companyName}
                  id="companyName"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ alignItems: 'center' }}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={2}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Address 1
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  placeholder="Address 1"
                  size="small"
                  value={formData.address1}
                  onChange={(e) => handleChange('address1', e.target.value)}
                  // error={Boolean(formErrors.address1)}
                  // helperText={formErrors.address1}
                  id="address1"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ alignItems: 'center' }}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={2}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Address 2
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  placeholder="Address 2"
                  size="small"
                  value={formData.address2}
                  onChange={(e) => handleChange('address2', e.target.value)}
                  // error={Boolean(formErrors.address2)}
                  // helperText={formErrors.address2}
                  id="address2"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    State
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
              <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={stateList}
                  getOptionLabel={(option) => option.name}
                  value={formData.state !== '' ? formData.state : null}
                  onChange={(event, newValue) => handleChange('state', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="State" />}
                  error={formErrors.state}
                  helperText={formErrors.state}
                  id="state"
                  // disabled={formData && formData.workType === 'remote'}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    City
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
              <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={cityList}
                  getOptionLabel={(option) => option.cityName}
                  value={formData.city !== '' ? formData.city : null}
                  onChange={(event, newValue) => handleChange('city', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="City" />}
                  error={formErrors.city}
                  helperText={formErrors.city}
                  id="city"
                  // disabled={formData && formData.workType === 'remote'}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Zipcode
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
              <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={zipcodes}
                  getOptionLabel={(option) => option.zipcode}
                  value={formData.zipcode !== '' ? formData.zipcode : null}
                  onChange={(event, newValue) => handleChange('zipcode', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Zipcode" />}
                  error={formErrors.zipcode}
                  helperText={formErrors.zipcode}
                  id="zipcode"
                />
              </Grid>
            </Grid>
          </Grid>
         
          
        </Grid>
              </Grid>
              <Grid item xs={4}>
              <Grid
          container
          spacing={1}
          sx={{
            '.css-r0m7rw-MuiInputBase-root-MuiOutlinedInput-root': {
              height: '34.5px',
            },
            '& .MuiInputBase-input': {
              fontSize: '12px',
            },
            p: '10px'
          }}
        >
          <Grid item xs={12}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Inovice Date
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker sx={{width:'100%'}}
                    value={formData.invoiceDate}
                    onChange={(newValue) => handleChange('invoiceDate', newValue)}
                    renderInput={(params) => <TextField fullWidth {...params}  sx={{ width: '100%' }} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Invoice Total
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth disabled
                  placeholder="Total"
                  size="small" type='number'
                  value={formData.invoiceTotal}
                  onChange={(e) => handleChange('invoiceTotal', e.target.value)}
                  // error={Boolean(formErrors.invoiceTotal)}
                  // helperText={formErrors.invoiceTotal}
                  id="invoiceTotal"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Discount
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth disabled
                  placeholder="Discount"
                  size="small"
                  value={formData.totalDiscount}
                  onChange={(e) => handleChange('totalDiscount', e.target.value)}
                  // error={Boolean(formErrors.totalDiscount)}
                  // helperText={formErrors.totalDiscount}
                  id="totalDiscount"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Tax
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth disabled
                  placeholder="Tax"
                  size="small"
                  value={formData.tax}
                  onChange={(e) => handleChange('tax', e.target.value)}
                  // error={Boolean(formErrors.tax)}
                  // helperText={formErrors.tax}
                  id="tax"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Total
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth disabled
                  placeholder="Total"
                  size="small" type='number'
                  value={formData.grandTotal}
                  onChange={(e) => handleChange('grandTotal', e.target.value)}
                  // error={Boolean(formErrors.grandTotal)}
                  // helperText={formErrors.grandTotal}
                  id="grandTotal"
                  autoComplete="off"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Payment Terms
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
              <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={paymentTermsList}
                  getOptionLabel={(option) => option}
                  value={formData.dueOnReciept !== '' ? formData.dueOnReciept : null}
                  onChange={(event, newValue) => handleChange('dueOnReciept', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Payment Terms" />}
                  error={formErrors.dueOnReciept}
                  helperText={formErrors.dueOnReciept}
                  id="dueOnReciept"
                  // disabled
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                  <Typography variant="body2" sx={{ ...textStyles }}>
                    Due Date
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker sx={{width:'100%'}}
                    value={formData.dueDate}
                    onChange={(newValue) => handleChange('dueDate', newValue)}
                    renderInput={(params) => <TextField fullWidth {...params}  sx={{ width: '100%' }} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
              </Grid>

              {/* Lines */}
              <Grid item xs={12}>
              <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            width: '100%',
            // height: window.innerHeight - 100,
            // bgcolor: '#F2F4FA',
            // p: '10px',
          }}
        >
          <TableContainer component={Paper} elevation={4}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Item ID</StyledTableCell>
                  <StyledTableCell align="left">Item Name </StyledTableCell>
                  <StyledTableCell align="left">Item Description </StyledTableCell>
                  <StyledTableCell align="left">UOM</StyledTableCell>
                  <StyledTableCell align="left">Quantity</StyledTableCell>
                  <StyledTableCell align="left">Price($)</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows &&
                  rows?.map((row) => (
                    <StyledTableRow key={row.itemid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <StyledTableCell component="th" scope="row">
                        {row.itemid}
                      </StyledTableCell>
                      <StyledTableCell align="left">{row.itemName}</StyledTableCell>
                      <StyledTableCell align="left">{row.itemDescription}</StyledTableCell>
                      <StyledTableCell align="left">{row.uom}</StyledTableCell>
                      <StyledTableCell align="left">{row.quantity}</StyledTableCell>
                      <StyledTableCell align="left">{row.price}</StyledTableCell>
                      
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
              </Grid>
            
             </Grid>
             <Box sx={{display:'flex', justifyContent: 'end', mt:'10px'}}>
             <Box sx={{display: 'flex', gap:'6px', alignItems: 'center'}}>
              <Button variant='outlined' onClick={handleClose}>Cancel</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Create Invoice
              </Button>

            </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
